module.exports = __webpack_public_path__ + "static/media/boolean_operator_xor.f4cf4eb4.svg";